import React from 'react'
import Staking from '../Components/Staking/Staking';


const staking = () => {
  return (
    <>
        <Staking />
    </>
  )
}

export default staking;